module.exports = __webpack_public_path__ + "static/media/icon_duoyang.9654d371.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageSecAwarenrssSolution/icon_duoyang.svg
// module id = 227
// module chunks = 0